import { render, staticRenderFns } from "./IPCSimulation.vue?vue&type=template&id=07fd4445&scoped=true&"
import script from "./IPCSimulation.vue?vue&type=script&lang=js&"
export * from "./IPCSimulation.vue?vue&type=script&lang=js&"
import style0 from "./IPCSimulation.vue?vue&type=style&index=0&id=07fd4445&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fd4445",
  null
  
)

export default component.exports